import { Injectable } from '@angular/core';

import { Subject, Observable } from 'rxjs';
import $ from 'jquery';

@Injectable({
  providedIn: 'root',
})
export class InputGewijzigdService {
  private _inputGewijzigd = new Subject<void>();

  // TODO Mogelijk is er een betere oplossing voor het bepalen of subject gevuld mag worden.
  // In onderstaande code wordt het subject namelijk ook gevuld als de lengte van de
  // cdk-overlay-backdrop gelijk is aan 1 én als het inputId gelijk is aan zending_begindatum_input.
  // Die situatie doet zich voor als er een datum wordt gekozen in een kalender-popup.
  inputGewijzigd(inputId = '') {
    // Als de aanpassing is gedaan in een modal, geef de input wijziging niet direct door tijdens het aanpassen.
    // De wijziging hoeft alleen doorgegeven te worden als in de modal wordt een actie aangeroepen dat zorgt dat de
    // parent form input ook wijzigd (zoals het opslaan van een nieuw adres via een modal, dat ook aan de parent form
    // toegevoegd wordt). Dit wordt dan bij het sluiten van de modal doorgegeven, wanneer de modal-backdrop niet langer
    // bestaat.
    if (
      ($('.modal-backdrop').length == 0 && $('.cdk-overlay-backdrop').length == 0) ||
      ($('.cdk-overlay-backdrop').length == 1 && inputId == 'zending_begindatum_input')
    ) {
      this._inputGewijzigd.next();
    }
  }

  public get inputGewijzigd$(): Observable<void> {
    return this._inputGewijzigd.asObservable();
  }
}
